import React, { useContext } from 'react';
import { InboundContext } from '../../../../context/InboundContext';
import { RadioButton } from '../../../common';
import { Heading, Input, Text } from '../../../styledComponents';
import styles from '../FormContainer.module.css';

type PaymentDetailsType = {
  paymentType: string;
  paymentEmail: string;
};

type PaymentDetailsProps = {
  paymentDetails: PaymentDetailsType;
  setPaymentDetails: React.Dispatch<React.SetStateAction<PaymentDetailsType>>;
  paymentEmailError?: string;
  onPaymentEmailBlur?: () => void;
};

export default function PaymentDetails({
  paymentDetails,
  setPaymentDetails,
  paymentEmailError = '',
  onPaymentEmailBlur,
}: PaymentDetailsProps) {
  const { inboundData, t } = useContext(InboundContext);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPaymentDetails({ ...paymentDetails, [name]: value });
  };

  const handleRadioButtonChange = (val: string) => {
    setPaymentDetails({ ...paymentDetails, paymentType: val });
  };

  return (
    <div>
      {inboundData?.formSetupPage?.payment && (
        <div className={styles.formSection}>
          <Heading as="h3" fontWeight="500" fontSize="16px" color="#353535" textTransform="uppercase">
            {t('paymentDetailsHeader')}
          </Heading>

          <Text color="#667085" fontSize="14px">
            {t('paymentDetailsSubTitle')} *
          </Text>

          <div className={styles.paymentDetails}>
            <div className={styles.paymentMethodContainer}>
              {inboundData?.formSetupPage?.allowedPaymentMethods.find((v) => v === 'paypal') && (
                <RadioButton
                  id="paymentType"
                  name="paymentType"
                  value="Paypal"
                  onChange={() => handleRadioButtonChange('paypal')}
                  checked={paymentDetails.paymentType === 'paypal'}
                  text="Paypal"
                />
              )}
              {inboundData?.formSetupPage?.allowedPaymentMethods.find((v) => v === 'venmo') && (
                <RadioButton
                  id="paymentType"
                  name="paymentType"
                  value="Venmo"
                  onChange={() => handleRadioButtonChange('venmo')}
                  checked={paymentDetails.paymentType === 'venmo'}
                  text="Venmo"
                />
              )}
            </div>
            <div className={styles.emailContainer}>
              <Input
                type="text"
                inputMode="email"
                autoComplete="email"
                placeholder={paymentDetails.paymentType === 'paypal' ? t('paypalPlaceholder') : t('venmoPlaceholder')}
                name="paymentEmail"
                value={paymentDetails.paymentEmail}
                onChange={handleInputChange}
                onBlur={onPaymentEmailBlur}
                fontSize="14px"
                required
                isError={!!paymentEmailError}
              />
              {paymentEmailError && (
                <Text className={styles.paymentEmailError} color="#e64848" fontSize="14px">
                  {paymentEmailError}
                </Text>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
